import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4 6H2v16h16v-2H4V6zm18-4H6v16h16V2zm-3 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
}), 'QueueSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/QueueSharp.js
// module id = 5655
// module chunks = 2